import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const BUTTON_WIDTH = '136px';

export const Container = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  & button {
    min-width: ${BUTTON_WIDTH};
    &[disabled] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export const ButtonContainer = styled.div`
  height: 100%;
  min-width: ${BUTTON_WIDTH};
  width: ${BUTTON_WIDTH};
  padding-bottom: ${Spacing.HALF};
  ${Mixins.Flex.setColumn('flex-start')}
`;

export const ButtonText = styled.div`
  padding: ${Spacing.HALF} ${Spacing.HALF} 0;
  text-align: left;
  ${Font.bySize(Font.Size.S, Font.Weight.SEMI_BOLD)}
  ${Mixins.Text.overflow(3)}
`;

export const Image = styled(DynamicImage).attrs(() => ({
  sourceHeight: 400,
  sourceWidth: 400,
}))`
  height: 104px;
  width: ${BUTTON_WIDTH};
`;

export const SubHeaderContainer = styled.div`
  margin-bottom: ${Spacing.QUARTER};
  ${Mixins.Flex.set('space-between')}
`;

export const SubHeaderContent = styled.div`
  ${Font.bySize(Font.Size.XS, Font.Weight.SEMI_BOLD)}
`;

export const SelectedOptionsContainer = styled.div`
  flex-wrap: wrap;
  gap: ${Spacing.HALF};
  margin-top: ${Spacing.SINGLE};
  ${Mixins.Flex.set()}

  &:empty {
    margin-top: 0;
  }
`;

export const SelectedOption = styled.div`
  border: ${Border.Base} ${Colors.KOHLRABI_LITE_10};
  border-radius: ${Border.Radius.M};
  background: ${Colors.KOHLRABI_LITE_40};
  padding: ${Spacing.HALF} ${Spacing.THREE_QUARTERS};
  ${Font.bySize(Font.Size.XS, Font.Weight.SEMI_BOLD)}
  ${Mixins.Flex.set('space-between')}
`;

export const SelectedOptionLabel = VerticallyCenteredText;
